import { ArrowDownWideNarrow, ArrowUpNarrowWide, ChevronsUpDown } from '@tamagui/lucide-icons';
import { Spinner } from '@unistocks/components/loading/spinner/spinner';
import { Sorting } from '@unistocks/components/table/table';
import { SortOrder } from '@unistocks/proxy/axios-client';

export type SortIconProps<TFilter extends Sorting> = {
  prop: TFilter['prop'];
  sorting: Sorting;
  isLoading?: boolean;
};

export function SortIcon<TFilter extends Sorting>({
  prop,
  sorting,
  isLoading
}: SortIconProps<TFilter>) {
  if (sorting.prop === prop) {
    if (isLoading) {
      return <Spinner scale={0.7} />;
    }
    return sorting.direction === SortOrder.Ascending ? (
      <ArrowUpNarrowWide color={'$color'} size={14} />
    ) : (
      <ArrowDownWideNarrow color={'$color'} size={14} />
    );
  }

  return <ChevronsUpDown color={'$headingFont'} size={14} />;
}

SortIcon.displayName = 'SortIcon';
